/**
 * kr
 */

'use strict';
import AppKr from '@/_modules/app_kr';

document.addEventListener('DOMContentLoaded', () => {
  new AppKr();
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});
